export interface EditorFont {
  family: string;
  label: string;
}

export const EDITOR_TEXT_FONTS: EditorFont[] = [
  // Fix #11 (2026-05-28): Londrina Solid first — it's the brand default
  // (the "Par défaut" value in the picker maps to it visually).
  { family: "'Londrina Solid', Impact, sans-serif",              label: 'Londrina Solid' },
  // Serifs (editorial, classic)
  { family: "'Fraunces', 'Cormorant Garamond', Georgia, serif", label: 'Fraunces' },
  { family: "'Playfair Display', 'Fraunces', Georgia, serif",   label: 'Playfair Display' },
  { family: "'Cormorant Garamond', Georgia, serif",              label: 'Cormorant' },
  // Small caps (2026-10-14): the « Lieu · date » of the Mariage and Religieux themes.
  { family: "'Cormorant SC', 'Cormorant Garamond', Georgia, serif", label: 'Cormorant SC' },
  { family: "'Lora', Georgia, serif",                            label: 'Lora' },
  { family: "'Roboto Slab', 'Lora', Georgia, serif",             label: 'Roboto Slab' },
  { family: "'Abril Fatface', 'Playfair Display', Georgia, serif", label: 'Abril Fatface' },
  // Display / impact
  { family: "'Bebas Neue', Impact, sans-serif",                  label: 'Bebas Neue' },
  { family: "'Oswald', 'Bebas Neue', Impact, sans-serif",        label: 'Oswald' },
  { family: "'Anton', Impact, sans-serif",                       label: 'Anton' },
  { family: "'Gasoek One', Impact, sans-serif",                  label: 'Gasoek One' },
  { family: "'Bungee', Impact, sans-serif",                      label: 'Bungee' },
  // Modern sans
  { family: "'Inter', 'DM Sans', system-ui, sans-serif",         label: 'Inter' },
  { family: "'Montserrat', system-ui, sans-serif",               label: 'Montserrat' },
  { family: "'Poppins', system-ui, sans-serif",                  label: 'Poppins' },
  { family: "'Quicksand', system-ui, sans-serif",                label: 'Quicksand' },
  { family: "'DM Sans', system-ui, sans-serif",                  label: 'DM Sans' },
  { family: "'Fredoka', system-ui, sans-serif",                  label: 'Fredoka' },
  { family: "'Ruda', system-ui, sans-serif",                     label: 'Ruda' },
  // Scripts / formal
  { family: "'Great Vibes', 'Dancing Script', cursive",          label: 'Great Vibes' },
  { family: "'Sacramento', 'Dancing Script', cursive",           label: 'Sacramento' },
  { family: "'Dancing Script', cursive",                         label: 'Dancing Script' },
  { family: "'Pacifico', 'Dancing Script', cursive",             label: 'Pacifico' },
  { family: "'Lobster', cursive",                                label: 'Lobster' },
  // Handwriting / casual
  { family: "'Caveat', 'Dancing Script', cursive",               label: 'Caveat' },
  { family: "'Indie Flower', 'Caveat', cursive",                 label: 'Indie Flower' },
  { family: "'Shadows Into Light', 'Caveat', cursive",           label: 'Shadows Into Light' },
  { family: "'Permanent Marker', 'Bebas Neue', sans-serif",      label: 'Permanent Marker' },
  { family: "'Amatic SC', 'Caveat', cursive",                    label: 'Amatic SC' },
  { family: "'Special Elite', 'Courier New', monospace",         label: 'Special Elite' },
  // Arabic (2026-09-30) — the only family here with Arabic letters; the album
  // agent writes Arabic phrases in it (worker lib/readableText.ts).
  { family: "'Amiri', 'Playfair Display', Georgia, serif",       label: 'Amiri (عربي)' },
];

export const DEFAULT_COVER_FONT = EDITOR_TEXT_FONTS.find((f) => f.label === 'Londrina Solid')
  ?? EDITOR_TEXT_FONTS[0];

/** « 'Playfair Display', Georgia, serif » → « Playfair Display » (the picker's label when it has one). */
export function fontName(family: string): string {
  const known = EDITOR_TEXT_FONTS.find((f) => f.family === family)?.label;
  return known ?? (String(family).split(',')[0] ?? '').replace(/['"]/g, '').trim();
}
